import React from 'react';
import { Stack, Text, Spinner, SpinnerSize } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';
import { CardScreen } from './CardScreen';
import { t } from '@/strings/index';

/**
 * LoadingScreen shows a loading spinner with back navigation
 */
const LoadingScreen: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  return (
    <CardScreen
      title=""
      onBackClick={handleBack}
      logoAltText="Company logo"
      showBackButton={false}
      showUserInfo={false}
    >
      <Stack horizontalAlign="center" verticalAlign="center" tokens={{ childrenGap: 16 }} className="loading-container">
        <Spinner size={SpinnerSize.large} />
        <Text variant="medium" className="loading-text">
          {t('api.loading')}
        </Text>
      </Stack>
    </CardScreen>
  );
};

export default LoadingScreen;